var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo35(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.686 17.67v10.736c0 .75-.609 1.358-1.36 1.358h-2.304a.136.136 0 01-.136-.136V18.892c0-.75.608-1.358 1.36-1.358h2.304c.075 0 .136.061.136.136z",
    fill: "url(#logo_35_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 1.425V13.99c0 .074-.06.135-.135.135H7.826c-.752 0-1.36-.608-1.36-1.357V.202c0-.075.06-.136.136-.136H8.92c.752 0 1.36.608 1.36 1.358z",
    fill: "url(#logo_35_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 23.979v9.659c0 .75-.608 1.357-1.36 1.357H6.602a.136.136 0 01-.136-.136v-9.658c0-.75.608-1.358 1.36-1.358h2.319c.075 0 .136.061.136.136z",
    fill: "url(#logo_35_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.804 27.301v6.337c0 .749-.609 1.357-1.36 1.357H.136A.136.136 0 010 34.859v-6.337c0-.75.609-1.357 1.36-1.357h2.308c.075 0 .136.06.136.136z",
    fill: "url(#logo_35_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.686 6.661v5.504c0 .075-.06.136-.136.136h-2.304c-.752 0-1.36-.608-1.36-1.358V5.44c0-.075.06-.136.136-.136h2.304c.75 0 1.36.608 1.36 1.358z",
    fill: "url(#logo_35_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.804 1.426v6.337c0 .075-.06.136-.136.136H1.36C.61 7.899 0 7.29 0 6.542V.204C0 .129.06.068.136.068h2.308c.751 0 1.36.608 1.36 1.358z",
    fill: "url(#logo_35_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.998 34.864v-9.023c0-.864-.344-1.693-.956-2.304l-3.335-3.328a3.268 3.268 0 00-2.308-.954h-9.04a.136.136 0 00-.136.136v9.023c0 .864.343 1.693.956 2.304l3.334 3.328a3.266 3.266 0 002.308.954h9.04a.136.136 0 00.137-.136z",
    fill: "url(#logo_35_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.998.136V9.16c0 .864-.344 1.692-.956 2.303l-3.335 3.328a3.268 3.268 0 01-2.308.954h-9.04a.136.136 0 01-.136-.136V6.586c0-.864.343-1.693.956-2.304L23.512.954A3.267 3.267 0 0125.821 0h9.04c.076 0 .137.061.137.136z",
    fill: "url(#logo_35_svg__paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint0_linear",
    x1: 12.504,
    y1: 17.574,
    x2: 18.367,
    y2: 29.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint1_linear",
    x1: 6.083,
    y1: 0.113,
    x2: 13.343,
    y2: 12.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint2_linear",
    x1: 6.083,
    y1: 23.879,
    x2: 11.118,
    y2: 34.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint3_linear",
    x1: -0.382,
    y1: 27.19,
    x2: 2.347,
    y2: 35.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint4_linear",
    x1: 12.504,
    y1: 5.326,
    x2: 14.728,
    y2: 13.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint5_linear",
    x1: -0.382,
    y1: 0.094,
    x2: 2.347,
    y2: 8.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint6_linear",
    x1: 17.639,
    y1: 19.306,
    x2: 20.507,
    y2: 37.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_35_svg__paint7_linear",
    x1: 34.998,
    y1: 0,
    x2: 19.253,
    y2: 15.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })))));
}

export default SvgLogo35;